import { PlayArrow, Pause, PlayCircle } from '@mui/icons-material';
import { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import '../../App.css'
import { useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button'
import { SelectGenericFromTable } from '../universal/Axios';
import { getStore } from '../../Store'
import { observer } from "mobx-react"
import { HandleDownload } from '../universal/IOHelper';
import apiClient from '../../apiClient';
const store = getStore();


const OutputTable = observer(({ filetype, network_run_id }) => {
    let persisterFilesData = store.persisterFiles

    useEffect(() => {
        SelectGenericFromTable("select * from persister_file where network_run_id = '" + network_run_id + "'", store.updatePersisterFiles)
    }, []);

    const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState(false);
    const [audio, setAudio] = useState(new Audio())

    if (persisterFilesData === undefined || (persisterFilesData.length > 0 && persisterFilesData[0].network_run_id !== network_run_id)) {
        return (<p>loading...</p>)
    }

    const toggleAudioPlay = ({ source }) => {
        console.log(source)
        if (audio.src == source && currentlyPlayingAudio) {
            audio.pause();
            setCurrentlyPlayingAudio(false);
        }
        else {
            if (audio.src != source) {
                audio.src = source;
            }
            audio.play();
            setCurrentlyPlayingAudio(true)
        }
    }

    const getAudioButtonFromStatus = (file_name) => {
        if (audio.src.includes(file_name)) {
            return currentlyPlayingAudio ? <Pause /> : <PlayArrow />
        }
        return <PlayCircle />
    }

    const persisterFileColumns = [
    {
        field: 'id',
        headerName: '',
        width: 130,
        renderCell: (params) => {
            return <>
            {filetype === "wav" && <>
                    <Button
                        onClick={() => { toggleAudioPlay(params.row) }}
                    >
                        {getAudioButtonFromStatus(params.row.source)}
                    </Button>
            </>}
                <Button
                    onClick={() => { HandleDownload(params.row.bucket, params.row.folder, params.row.name) }}
                >
                    <DownloadIcon />
                </Button>
            </>
        },
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 400,
    },
    {
        field: 'folder',
        headerName: 'folder',
        width: 520
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 520
    },
    {
        field: 'bucket',
        headerName: 'bucket',
        width: 520
    },
    ];
    if (filetype === "wav") { 
        persisterFileColumns.push(
        {
            field: 'source',
            headerName: 'Source',
                valueGetter: (params) => {
                    var link = "https://storage.cloud.google.com/" + params.row.bucket + "/"
                    if (params.row.folder != null) {
                        link += params.row.folder + "/"
                    }
                    link += params.row.name
                    return link
                },
            hide: true
        })
    }

    const persisterFilesRows = persisterFilesData?.filter(data => data != null && data.name.includes("." + filetype)).map((persisterFile) =>
    ({   
        id: persisterFile.id,
        name: persisterFile.name,
        bucket: persisterFile.bucket,
        folder: persisterFile.folder,
        type: persisterFile.type,
        description: persisterFile.description,
        source: (persisterFile.folder == null ? "https://storage.cloud.google.com/" + persisterFile.bucket + "/" + persisterFile.name
            : "https://storage.cloud.google.com/" + persisterFile.bucket + "/" + persisterFile.folder + persisterFile.name)
    }))

    return (
        <Box sx={{ height: filetype === "json" ? 500 : 300 }}>
            <DataGrid
                disableSelectionOnClick
                rows={persisterFilesRows}
                columns={persisterFileColumns}
                pagination={true}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
            />
        </Box>
    )
});

export { OutputTable };
